import React from 'react';
import { Section } from './Section';
export function HookSection() {
  return <Section eyebrow="Te suena, ¿no?" tone="darker" data-id="element-67" data-mp="7idio1nsa95f">
      <figure className="mx-auto max-w-lg" data-id="element-68" data-mp="7hud7kfbld8a">
        <div className="rounded-2xl border border-ink-700 bg-ink-800 p-4 shadow-2xl" data-id="element-69" data-mp="m79zan3wouhn">
          <div className="mb-3 flex items-center gap-3 border-b border-ink-700 pb-3" data-id="element-70" data-mp="m92w7aopw0cg">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-ink-600 font-display text-sm font-bold text-slate-300" data-id="element-71" data-mp="ha9uefislxs4">
              M
            </div>
            <div data-id="element-72" data-mp="3kq746nd1l3px">
              <p className="text-sm font-semibold text-white" data-id="element-73" data-mp="3kqqh1pnu51x3">Martín</p>
              <p className="text-xs text-safe-500" data-id="element-74" data-mp="2k2advd506pb">en línea</p>
            </div>
          </div>
          <blockquote className="max-w-[85%] rounded-2xl rounded-tl-sm bg-ink-700 px-4 py-3 text-[15px] leading-relaxed text-slate-100" data-id="element-75" data-mp="3um0ee03agl4j">
            "Hola, ¿me hacés un favor? Necesito pagar algo y no me anda la app, ¿me prestás 50 lucas
            y te las devuelvo mañana?"
          </blockquote>
          <p className="mt-2 pl-1 text-[11px] uppercase tracking-wider text-slate-500" data-id="element-76" data-mp="3gzwqk5s3qy14">
            Hoy · 21:14
          </p>
        </div>
        <figcaption className="sr-only" data-id="element-77" data-mp="3m25gsudlblzj">Mensaje típico de una estafa por WhatsApp</figcaption>
      </figure>

      <div className="mx-auto mt-9 max-w-2xl space-y-5 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-78" data-mp="3pzteu6akxuvn">
        <p data-id="element-79" data-mp="2yagj0yi025b7">
          Seguro recibiste este mensaje de un amigo. O peor:{' '}
          <span className="font-semibold text-white" data-id="element-80" data-mp="2y8dp43dq7s17">
            alguien lo envió desde tu cuenta de WhatsApp a todos tus contactos.
          </span>
        </p>
        <p data-id="element-81" data-mp="37ad4kr93eo21">
          En lo que tardaste en leer estas líneas, un estafador en algún lugar del país acaba de
          hackear una cuenta nueva.
        </p>
        <p className="border-l-2 border-shield-500 pl-4 font-semibold text-white" data-id="element-82" data-mp="2emr1dk3s1lfp">
          Hoy no se trata de "si" te va a pasar, sino de CUÁNDO te va a pasar si no tomás medidas
          ahora.
        </p>
      </div>
    </Section>;
}